import { Component } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { slideInOutAnimation } from '../slide-in-out-animation';

@Component({
    animations: [slideInOutAnimation],
    selector: 'tt-no-legend',
     imports: [
    MatExpansionModule,
    TranslateModule
  ],
 templateUrl: './no-legend.component.html',
    styleUrls: ['../legend.component.scss'],
    standalone: true
})
export class NoLegendComponent {
  active: boolean;
  constructor(
    public translate: TranslateService
  ) { }
}